// @packages
import React, { useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { Text } from '@rneui/themed';
import { View, Linking, Pressable } from 'react-native';
import { useNavigate } from 'react-router-native';

// @scripts
import Button from '../../atoms/button';
import Input from '../../atoms/input';
import useStyles from './styles';
import { globalUI } from '../../../core';
import { Durations } from '../../../utils/types';
import { config } from '../../../core/config';
import { routesOutLogged } from '../../../core/routes/config';
import { signIn } from '../../../services/login-service';
import { useAuth } from '../../../core/context/provider';

const Login = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const styles = useStyles();
  const {
    control,
    handleSubmit
  } = useForm();
  const {
    onLogin,
    onUserForgotPassword,
    onCleanUserForgotPassword
  } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (data: FieldValues) => {
    try {
      setIsLoading(true);
      const response = await signIn(data.userName, data.password);
      setIsLoading(false);
      if (response.challengeName) {
        onUserForgotPassword(data.userName);
        navigate(routesOutLogged.changePassword.path);
      } else {
        onLogin(response);
        if (!response.siteIds.length) globalUI.showToast(config.text.login.noSites, Durations.LONG);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const openUpUrl = () => {
    globalUI.showToast(config.text.login.loginRedirectMessage, Durations.LONG);
    setTimeout(
      () => {
        Linking.openURL(config.settings.login.urlPrivacy);
      },
      3000
    );
  };

  const onPressBottomHelpers = (uri: string) => {
    onCleanUserForgotPassword();
    navigate(uri);
  };

  return (
    <View style={styles.container}>
      <Input
        control={control}
        isRequired
        label={config.text.login.userNameLabel}
        leftIcon={{
          name: 'person-outline',
          type: 'material'
        }}
        name="userName"
        placeholder={config.text.login.userNamePlaceholder}
      />
      <Input
        control={control}
        isRequired
        label={config.text.login.passwordLabel}
        leftIcon={{
          name: 'lock-outline',
          type: 'material'
        }}
        name="password"
        placeholder={config.text.login.passwordPlaceholder}
        secureText
      />
      <Button
        color="secondary"
        isLoading={isLoading}
        onClick={handleSubmit(onSubmit)}
        title={config.text.login.button}
      />
      <View style={styles.bottomHelper}>
        <Pressable onPress={openUpUrl}>
          <Text
            style={styles.textBottom}
          >
            {config.text.login.privacy}
          </Text>
        </Pressable>
        <Pressable
          onPress={() => onPressBottomHelpers(routesOutLogged.forgotPassword.path)}
        >
          <Text
            style={styles.textBottom}
          >
            {config.text.login.forgotPassword}
          </Text>
        </Pressable>
      </View>
    </View>
  );
};

export default Login;
